/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'RIDP' store object.
 * @namespace RIDPSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UARIDP';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static fetchPrimaryRIDP = state => state[selectors.moduleIdentifier].fetchPrimaryRIDP.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static isFetchingFetchPrimaryRIDP = state =>
    state[selectors.moduleIdentifier].isFetchingFetchPrimaryRIDP.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static fetchPrimaryRIDPError = state =>
    state[selectors.moduleIdentifier].fetchPrimaryRIDPError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static postSecondaryRIDP = state => state[selectors.moduleIdentifier].postSecondaryRIDP.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static isFetchingPostSecondaryRIDP = state =>
    state[selectors.moduleIdentifier].isFetchingPostSecondaryRIDP.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static postSecondaryRIDPError = state =>
    state[selectors.moduleIdentifier].postSecondaryRIDPError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static fetchFarsResponse = state => state[selectors.moduleIdentifier].fetchFarsResponse.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static isFetchingFetchFarsResponse = state =>
    state[selectors.moduleIdentifier].isFetchingFetchFarsResponse.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static fetchFarsResponseError = state =>
    state[selectors.moduleIdentifier].fetchFarsResponseError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static postCompleteFARs = state => state[selectors.moduleIdentifier].postCompleteFARs.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static isFetchingPostCompleteFARs = state =>
    state[selectors.moduleIdentifier].isFetchingPostCompleteFARs.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static postCompleteFARsError = state =>
    state[selectors.moduleIdentifier].postCompleteFARsError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static postRbaRIDP = state => state[selectors.moduleIdentifier].postRbaRIDP.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static isFetchingPostRbaRIDP = state =>
    state[selectors.moduleIdentifier].isFetchingPostRbaRIDP.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static postRbaRIDPError = state => state[selectors.moduleIdentifier].postRbaRIDPError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static postGetRecordResponse = state =>
    state[selectors.moduleIdentifier].postGetRecordResponse.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static isFetchingPostGetRecordResponse = state =>
    state[selectors.moduleIdentifier].isFetchingPostGetRecordResponse.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof RIDPSelectors
   */
  static postGetRecordResponseError = state =>
    state[selectors.moduleIdentifier].postGetRecordResponseError.payload;
}
